<!-- Calendario completo -->
<div class="calendar-container">
  <!-- Información del vehículo -->
  @if (vehicle(); as vehicleData) {
  <div class="vehicle-info-section">
    <div class="vehicle-info">
      <h4 class="vehicle-name">{{ vehicleData.Name }}</h4>
      <div class="vehicle-image-container">
        @if (vehicleData.ImageFile?.FileUri) {
        <img [src]="vehicleData.ImageFile.FileUri" [alt]="vehicleData.Name" class="vehicle-image" />
        }
      </div>
    </div>
  </div>
  }

  <!-- Calendario -->
  <div class="calendar-wrapper" [class.invalid-date]="calendarInvalidSelection">
    <div class="calendar-header">
      <div class="calendar-month-year"><span class="calendar-month-name">{{ currentMonthName() }}</span> de {{ currentYear() }}</div>
      <div class="calendar-header-controls">
        <button type="button" class="calendar-nav-btn" [class.disabled]="!canNavigatePrevious()" [disabled]="!canNavigatePrevious()" (click)="previousMonth()" aria-label="Mes anterior">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button type="button" class="calendar-nav-btn" [class.disabled]="!canNavigateNext()" [disabled]="!canNavigateNext()" (click)="nextMonth()" aria-label="Mes siguiente">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="calendar-grid">
      <!-- Días de la semana -->
      <div class="calendar-weekdays">
        @for (weekDay of weekDays; track weekDay) {
        <div class="calendar-weekday">{{ weekDay }}</div>
        }
      </div>

      <!-- Días del mes -->
      <div class="calendar-days">
        @for (day of calendarDays(); track day.date.getTime(); let i = $index) {
        <div role="button" [tabindex]="day.status === 'available' && day.scheduledInit ? 0 : -1" class="calendar-day" [class.calendar-day-unavailable]="day.status === 'unavailable'" [class.calendar-day-available]="day.status === 'available'" [class.calendar-day-occupied]="day.status === 'occupied'" [class.calendar-day-selected]="day.status === 'selected'" [class.calendar-day-other-month]="!day.isCurrentMonth" [class.calendar-day-scheduled-init]="day.scheduledInit" [class.calendar-day-scheduled-end]="day.scheduledEnd" [class.calendar-day-hovered-block]="day.hoverInSchedule" [class.d-none]="i/7 >=5 && !day.isCurrentMonth" [style.--hover-delay]="day.hoverInSchedule ? day.hoverDelayMs + 'ms' : '0ms'" (click)="onDayClick(day)" (keydown.enter)="onDayClick(day)" (keydown.space)="onDayClick(day)" (mouseenter)="onDayHover(day)" (mouseleave)="onDayHoverEnd()" (focus)="onDayHover(day)" (blur)="onDayHoverEnd()" [attr.aria-label]="'Día ' + day.day + ', ' + day.status">
          <span class="calendar-day-number">{{ day.day }}</span>
        </div>
        }
      </div>
    </div>

    <!-- Leyenda -->
    <div class="legend-section">
      <div class="legend-items">
        <div class="legend-item">
          <span class="legend-color legend-unavailable"></span>
          <span class="legend-text">Día no disponible</span>
        </div>
        <div class="legend-item">
          <span class="legend-color legend-available"></span>
          <span class="legend-text">Día disponible</span>
        </div>
        <div class="legend-item">
          <span class="legend-color legend-occupied"></span>
          <span class="legend-text">Día ocupado</span>
        </div>
        <div class="legend-item">
          <span class="legend-color legend-selected"></span>
          <span class="legend-text">Día seleccionado</span>
        </div>
      </div>
    </div>
  </div>

  <div class="reservation-options">
    <!-- Resumen de reserva -->
    <div class="reservation-summary">
      @if (!hasAvailableDays()) {
      <i class="fa-regular fa-calendar-xmark text-danger"></i> <span class="text-danger">Ahora mismo no hay disponibilidad para nuevas reservas.</span><br>
      <small class="text-dark">Escríbenos un email a la dirección de correo electrónico que aparece en el pié de página y nos pondremos en contacto contigo en cuanto vuelva abrirse el cupo de reservas. ¡Gracias por tu interés!</small>
      } @else if (selectedDays().length > 0) {
      <i class="fas fa-calendar-days"></i> <strong> Periodo seleccionado:</strong> {{ selectedDaysText() }} antes de las 11:00 h.
      } @else {
      <i class="fas fa-calendar-days"></i> Selecciona un periodo en el calendario.
      }
    </div>
    <!-- Preferencia de hora -->
    <div class="time-preference-section" [class.invalid-time-preference]="timePreferenceInvalid">
      <label for="timePreference" class="time-preference-label">Preferencia de hora:</label>
      <select2 [data]="timePreferences" [value]="timePreference()" [disabled]="!hasAvailableDays()" (update)="timePreference.set($any($event).value)" (click)="timePreferenceInvalid = false" placeholder="Selecciona una opción"></select2>
    </div>
  </div>

  <!-- Botones de acción -->
  <div class="reservation-footer-actions">
    <button type="button" class="btn btn-outline-primary btn-lg" (click)="onBack()">Volver</button>
    <button type="button" class="btn btn-primary btn-lg" [disabled]="!hasAvailableDays()" (click)="onRequest()">Reservar</button>
  </div>
</div>
